import { createAction, props } from '@ngrx/store';

export const loadGroups = createAction('[RightSidebar/API] Load Groups');

export const loadGroupsSuccess = createAction(
  '[RightSidebar/API] Load Groups Success'
);

export const loadSuggested = createAction('[RightSidebar/API] Load Suggested');

export const loadSuggestedSuccess = createAction(
  '[RightSidebar/API] Load Suggested Success',
  props<{ items: any[] }>()
);
